import { CompositeDecorator } from 'draft-js';
import LinkDecorator from './LinkDecorator';

export default new CompositeDecorator([LinkDecorator]);




// WEBPACK FOOTER //
// ./src/components/form/RichEditor/decorators/index.js